import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-conferma',
  templateUrl: './conferma.component.html'
})
export class ConfermaComponent implements OnInit {
  Titolo: string = "Email Confermata";
  Testo: string = "La tua E-Mail è stata confermata con successo. \n Ora è possibile effettuare il login.";
  Success: boolean = false;
  pagetype:string = "ok";
  constructor(
    private route: ActivatedRoute,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(data => {
      this.pagetype= data['pagetype'];
      console.log(this.pagetype);
      if(this.pagetype == "ok"){
        this.Titolo = "Email Confermata";
        this.Testo = "La tua E-Mail è stata confermata con successo. \n Ora è possibile effettuare il login.";
        this.Success = true;
      } else if(this.pagetype == "utenteattivo"){
        this.Titolo = "Utente Attivo";
        this.Testo = "L'utente risulta gia registrato.";
      }else if(this.pagetype == "utenteerrato"){
        this.Titolo = "Utente Errato";
        this.Testo = "";
      }else if(this.pagetype == "chiaveerrata"){
        this.Titolo = "Chiave errata";
        this.Testo = "La chiave inserita non è valida.";
      }
    })
  }

}
